import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { tokens } from "./tokens";

interface Props {
    label: string;
    description: string;
}

const useStyles = makeStyles(() => ({
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        padding: "13px 0",
        borderBottom: `1px solid ${tokens.line}`,
        "&:last-child": {
            borderBottom: "none",
        },
    },
    label: {
        fontSize: "13.5px",
        fontWeight: 500,
        color: tokens.ink,
        display: "block",
    },
    description: {
        fontSize: "12px",
        color: tokens.hint,
    },
}));

export const ActionRow: React.FC<Props> = ({ label, description, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.row}>
            <div>
                <Typography component="b" className={classes.label}>{label}</Typography>
                <Typography component="span" className={classes.description}>{description}</Typography>
            </div>
            {children}
        </div>
    );
};
